/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';

import type { JSX } from '@ovhcloud/ods-stencil/components/message/custom-elements';

import { defineCustomElement as defineOsdsMessage } from '@ovhcloud/ods-stencil/components/message/custom-elements/osds-message.js';

export const OsdsMessage = /*@__PURE__*/createReactComponent<JSX.OsdsMessage, HTMLOsdsMessageElement>('osds-message', undefined, undefined, defineOsdsMessage);
